import { useQuery } from 'react-query';
import { Collection } from '../api';

export function useStructures() {
  const { data } = useQuery('structures', Collection.structures);

  return data;
}
